"use client"

import CssBaseline from "@mui/material/CssBaseline"
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles"
import { FC, PropsWithChildren } from "react"
import GlobalStyle from "./GlobalStyle"
import theme from "./theme"

// MUI v7 with Emotion:
// - Emotion cache provided by EmotionRegistry (App Router)
// - MUI ThemeProvider provides theme to Emotion styled components
// - CssBaseline for CSS reset
// - GlobalStyle for custom global styles

const ThemeProviders: FC<PropsWithChildren> = ({ children }) => (
  <MuiThemeProvider theme={theme}>
    <CssBaseline />
    <GlobalStyle />
    {children}
  </MuiThemeProvider>
)

export default ThemeProviders
